import React, { FunctionComponent } from 'react'
import { Grid, Text, Button, Heading, Option, Theme, useGetSelectedTheme, ButtonVariantComponent, ColorTypes } from '@afterpaytouch/core'
import { ProfileCard, TransMaskedText } from '..'
import { useCheckoutSizes } from '../../utils/responsive'
import { MarginTypes, Wrapper } from '../Wrapper'
import { Trans, useTranslation } from '../../utils/convergence'
import { MARGINS } from '../Wrapper/constants'
import styles from './style.module.css'

interface Props {
  email?: string
  isMobileLogin: boolean
  isLoading: boolean
  clickHandler: () => void
  emailSent: boolean
}

interface ThemeConfig {
  button: ButtonVariantComponent
  wrapperMarginSize: MarginTypes
  textColor?: ColorTypes
}

export const PasswordResetRequired: FunctionComponent<Props> = ({ email, isMobileLogin, isLoading, clickHandler, emailSent }) => {
  const { t } = useTranslation()
  const { buttonSize, textSize, headingSize } = useCheckoutSizes()
  const selectedTheme = useGetSelectedTheme()

  const themeConfigs: Record<Theme, ThemeConfig> = {
    [Theme.AP]: {
      button: Button.Ghost,
      wrapperMarginSize: MARGINS.DEFAULT,
    },
    [Theme.Cash]: {
      button: Button.Secondary,
      wrapperMarginSize: MARGINS.SMALL,
      textColor: 'Subtle',
    },
    [Theme.Pegasus]: {
      button: Button.Secondary,
      wrapperMarginSize: MARGINS.SMALL,
      textColor: 'Prominent',
    },
    [Theme.Kelpie]: {
      button: Button.Secondary,
      wrapperMarginSize: MARGINS.SMALL,
      textColor: 'Prominent',
    },
  }

  const themeConfig = themeConfigs[selectedTheme]
  const DesignLanguageButton = themeConfig.button

  return (
    <>
      <Heading size={headingSize}>{t('passwordResetRequired:heading')}</Heading>
      <Wrapper marginType={themeConfig.wrapperMarginSize}>
        <Option text={() => <ProfileCard allowLogout />} />
      </Wrapper>
      <Grid>
        <Text size={textSize} id='passwordResetRequiredLabel' color={themeConfig.textColor}>
          {isMobileLogin && t('passwordResetRequired:bodyForPhoneLogin')}
          {!isMobileLogin && (
            <Trans
              i18nKey='passwordResetRequired:body'
              components={{
                email: <TransMaskedText actionName='Password reset required' text={email ?? ''} testNameSpace='password-reset-required-email' />,
              }}
            />
          )}
        </Text>
      </Grid>
      <div className={styles.mt8}></div>
      {!emailSent && (
        <Grid>
          <Grid.Item>
            <DesignLanguageButton loading={isLoading} onClick={clickHandler} size={buttonSize} testNameSpace='send-link' padding='Fluid'>
              {t('passwordResetRequired:send')}
            </DesignLanguageButton>
          </Grid.Item>
        </Grid>
      )}
    </>
  )
}
